export class SidebarState {
  public visiblePanels: string[];
  public sidebarHidden: boolean;
  public activePanel: string;

  constructor(visiblePanels: string[], sidebarHidden: boolean, activePanel: string) {
    this.visiblePanels = visiblePanels;
    this.sidebarHidden = sidebarHidden;
    this.activePanel = activePanel;
  }
}
